<template>
    <b-container fluid class="animated fadeIn">
        <h1>{{tipoCreditoAssunto.codTipoCreditoAssunto != null ? 'ALTERAR' : 'INCLUIR'}}  CONFIGURAÇÃO TIPO DE CRÉDITO / ASSUNTO</h1>
        <b-card>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Tipo de Crédito: *" label-for="tipoCredito" class="text-label">
                        <multiselect
                            name="tipoCredito"
                            v-model="tipoCreditoAssunto.tipoCredito"
                            :show-labels="false"
                            :options="dados.tiposCredito"
                            :multiple="false"
                            :close-on-select="true"
                            :clear-on-select="true"
                            :preserve-search="false"
                            placeholder="Selecione"
                            track-by="id"
                            label="nome"
                            v-validate="{ required: true }"
                        >
                        </multiselect>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Assunto: *" label-for="assunto" class="text-label">
                        <multiselect
                                name="assunto"
                                v-model="tipoCreditoAssunto.codAssunto"
                                :show-labels="false"
                                :options="dados.assuntos"
                                :multiple="false"
                                :close-on-select="true"
                                :clear-on-select="true"
                                :preserve-search="false"
                                placeholder="Selecione"
                                track-by="codAssunto"
                                label="nome"
                                v-validate="{ required: true }"
                        >
                        </multiselect>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Tipo Origem: *" label-for="tipoOrigem" class="text-label"
                                  v-if="tipoCreditoAssunto.tipoCredito != null && tipoCreditoAssunto.tipoCredito.id == 1">
                        <multiselect
                                name="tipoOrigem"
                                v-model="tipoCreditoAssunto.codTipoOrigem"
                                :disabled="tipoCreditoAssunto.tipoCredito == null || tipoCreditoAssunto.tipoCredito.id != 1"
                                :show-labels="false"
                                :options="dados.tiposOrigem"
                                :multiple="false"
                                :close-on-select="true"
                                :clear-on-select="true"
                                :preserve-search="false"
                                placeholder="Selecione"
                                track-by="id"
                                label="nome"
                                v-validate="{ required: true }"
                        >
                        </multiselect>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-button variant="primary" @click.prevent="salvar" :disabled="inSave">
                        <i class="fa fa-save"></i> Salvar
                    </b-button>
                    <b-button variant="primary" class="ml-2" @click="voltar" :disabled="inSave">
                        <i class="fa fa-reply"></i> Voltar
                    </b-button>
                </b-col>
            </b-row>
        </b-card>
    </b-container>
</template>

<script>
import axios from 'axios'

export default {
    name: 'ManterTipoCreditoAssuntoEditar',
    data() {
        return {
            inSave: false,
            tipoCreditoAssunto: {
                codTipoCreditoAssunto: null,
                tipoCredito: null,
                codAssunto: null,
                codTipoOrigem: null,
            },
            dados: {
                tiposCredito: [],
                assuntos: [],
                tiposOrigem: []
            },
        }
    },
    methods: {
        salvar() {
            this.inSave = true;
            this.$validator.validateAll().then( async (result) => {
                if (!result) {
                    this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger' , errors: ['Favor preencher os campos obrigatórios (*)'] });
                    this.inSave = false;
                    window.scrollTo(0,0);
                    return
                }

                const urlApi = process.env.VUE_APP_ROOT_API;
                const token = JSON.parse(this.$store.getters.getUser).token.access_token;

                await axios.post(`${urlApi}/v1/tipoCreditoAssunto/verificarExistenciaTipoCredito`, this.tipoCreditoAssunto, {
                    headers: {
                        'Authorization': token,
                        'Content-Type': 'application/json',
                    }
                })
                .then(response => {
                    if(response.data) {
                        this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger' , errors: [`Já existe um registro ativo para o Tipo de Crédito informado.`] });
                        window.scrollTo(0,0);
                        return
                    }

                    axios.post(`${urlApi}/v1/tipoCreditoAssunto/salvar`, this.tipoCreditoAssunto, {
                        headers: {
                            'Authorization': token,
                            'Content-Type': 'application/json',
                        }
                    })
                    .then(response => {
                        if(response.data) {
                            this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger' , errors: [`${response.data.message}`] });
                            window.scrollTo(0,0);
                            return
                        }
                        this.$store.commit("setMsgTipoCreditoAssunto", 'Operação realizada com sucesso!!!')
                        this.$store.commit("setTipoCreditoAssunto", null);
                        this.$router.push({ path: '/tipo-credito-assunto' })
                    }).catch((error) => {
                        this.exibirErro(error)
                    }).finally(() => {
                        this.inSave = false
                    })
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.inSave = false
                })
            })
        },

        voltar() {
            this.$store.commit("setTipoCreditoAssunto", null);
            this.$router.push({ path: '/tipo-credito-assunto' })
        },

        /**
         * Exibe erros dos catch
         */
        exibirErro(error) {
            this.$store.commit("setMessages", { message: 'Erro!', errors: [error] });
        },

        /**
         * Listar tipos de crédito
         */
        async listarTipoCredito() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/parametros/listarTipoCredito`)
            .then(response => {
              this.dados.tiposCredito = response.data
            })
        },
        async listarAssuntos() {
            const urlApi = process.env.VUE_APP_ROOT_API;

            axios.get(`${urlApi}/v1/tipoCreditoAssunto/listarAssuntos`)
                .then(response => {
                    this.dados.assuntos = response.data;
                })
        },
        async listarTipoOrigem() {
            const urlApi = process.env.VUE_APP_ROOT_API;

            axios.get(`${urlApi}/v1/tipoCreditoAssunto/listarTipoOrigem`)
                .then(response => {
                    this.dados.tiposOrigem = response.data;
                })
        },

    },
    mounted() {
        this.$store.commit("setMessages", {});

        const tipoCreditoAssuntoEditada = this.$store.getters.getTipoCreditoAssunto;
        if(tipoCreditoAssuntoEditada) {
            this.tipoCreditoAssunto = tipoCreditoAssuntoEditada;
        }

        this.listarTipoCredito();
        this.listarAssuntos();
        this.listarTipoOrigem();
    }
    
}
</script>

<style scoped>

</style>